import React, { useEffect, useState } from "react";
import Select from "react-select";
import axios from "axios";
import { useNavigate } from "react-router-dom";

function JobCardAddNew() {
  const navigate = useNavigate();

  const token = sessionStorage.getItem("token");
  const headers = { headers: { Authorization: `Bearer ${token}` } };

  const [itemsList, setItemsList] = useState([]);
  const [workOrdersList, setWorkOrdersList] = useState([]);
  const [jobCardsList, setJobCardsList] = useState([]);

  const [selectedItem, setSelectedItem] = useState(null);
  const [selectedWorkOrder, setSelectedWorkOrder] = useState(null);
  const [selectedJobCard, setSelectedJobCard] = useState(null);

  const fetchItems = async (search = "") => {
    try {
      const payload = { search_parameter: search };
      const res = await axios.post(
        "/api/purple-fusion/itemdetail/getforsearch",
        payload,
        headers
      );
      const list = Array.isArray(res.data) ? res.data : [];
      const opts = list.map((it) => ({
        value: it.item_detail_id ?? it.id,
        label:
          it.name ||
          it.item_Name ||
          it.item_name ||
          it.code ||
          it.itemdetailname ||
          `Item-${it.item_detail_id ?? it.id}`,
        raw: it,
      }));
      setItemsList(opts);
    } catch (e) {
      console.error("fetchItems error", e);
      setItemsList([]);
    }
  };

  const fetchWorkOrdersByItem = async (itemId) => {
    try {
      // using search_parameter as used elsewhere; change to item_detail_id if backend requires
      const payload = { search_parameter: itemId, offset: 0, limit: 1000 };
      const res = await axios.post(
        "/api/purple-fusion/workorder/getforsearchandpaggination",
        payload,
        headers
      );
      // only include work orders whose status id is 2
      const list = Array.isArray(res.data) ? res.data : [];
      console.log(list);

      const filtered = list.filter((wo) => wo.status === "In Progress");
      const opts = filtered.map((wo) => ({
        value: wo.id,
        label: `${wo.code}   ${wo.item_Name} ${wo.status}`,
        raw: wo,
      }));
      setWorkOrdersList(opts);
    } catch (e) {
      console.error("fetchWorkOrdersByItem error", e);
      setWorkOrdersList([]);
    }
  };

  const fetchJobCardsByWorkOrder = async (workOrderId) => {
    try {
      const res = await axios.post(
        "/api/purple-fusion/jobcard/get",
        { work_order_id: workOrderId },
        headers
      );
      const list = Array.isArray(res.data) ? res.data : [];
      const opts = list.map((jc) => ({
        value: jc.id,
        label: jc.code || jc.workstation_name || `JC-${jc.id}`,
        raw: jc,
      }));
      setJobCardsList(opts);
    } catch (e) {
      console.error("fetchJobCardsByWorkOrder error", e);
      setJobCardsList([]);
    }
  };

  useEffect(() => {
    // lazy load nothing here; menu open will fetch. but we can prefetch small list if desired
  }, []);

  return (
    <div className="p-4">
      <h2 className="text-lg font-semibold mb-3">
        Create / Add Job Card (Select to open)
      </h2>

      <div className="flex flex-row gap-4 items-end">
        {/* <div style={{ minWidth: 260 }}>
          <label className="block text-xs mb-1">Item</label>
          <Select
            placeholder="Select item..."
            options={itemsList}
            onMenuOpen={() => fetchItems("")}
            value={selectedItem}
            onChange={(opt) => {
              setSelectedItem(opt);
              setSelectedWorkOrder(null);
              setSelectedJobCard(null);
              setWorkOrdersList([]);
              setJobCardsList([]);
              if (opt) fetchWorkOrdersByItem(opt.value);
            }}
          />
        </div> */}

        <div style={{ minWidth: 260 }}>
          <label className="block text-xs mb-1">Work Order</label>
          <Select
            placeholder="Select work order..."
            options={workOrdersList}
            onMenuOpen={() => {
              if (selectedItem) fetchWorkOrdersByItem(selectedItem.value);
              else fetchWorkOrdersByItem("");
            }}
            value={selectedWorkOrder}
            onChange={(opt) => {
              setSelectedWorkOrder(opt);
              setSelectedJobCard(null);
              setJobCardsList([]);
              if (opt) fetchJobCardsByWorkOrder(opt.value);
            }}
          />
        </div>

        <div style={{ minWidth: 260 }}>
          <label className="block text-xs mb-1">Job Card</label>
          <Select
            placeholder="Select job card..."
            options={jobCardsList}
            onMenuOpen={() => {
              if (selectedWorkOrder)
                fetchJobCardsByWorkOrder(selectedWorkOrder.value);
            }}
            value={selectedJobCard}
            onChange={(opt) => setSelectedJobCard(opt)}
          />
        </div>

        <div>
          <button
            disabled={!selectedJobCard}
            onClick={() => {
              if (!selectedJobCard) return;
              // optional: persist workorder/jobcard selection
              sessionStorage.setItem(
                "WorkOrderID",
                selectedWorkOrder?.value ?? ""
              );
              sessionStorage.setItem("jobcard", selectedJobCard?.label ?? "");
              navigate(`/jobcard/addAll/${selectedJobCard.value}`);
            }}
            className={`px-4 py-2 rounded ${
              selectedJobCard
                ? "bg-blue-600 text-white"
                : "bg-gray-300 text-gray-600"
            }`}
          >
            Add
          </button>
        </div>
      </div>
    </div>
  );
}

export default JobCardAddNew;
